module.exports = __webpack_public_path__ + "img/1001-Fasadenschnitt.e2a1a4bf.jpg";